import mapUtils from 'shared/app/utils/map-utils';

const pointMarkerZIndex = 20;
const bubbleMarkerZIndex = pointMarkerZIndex - 1;
const bubbleMarkerColor = '#00BDDF'; // Blue bubble marker where the user is geo-located

export const generateBubbleScale = (mapInstance, userGeolocation) => {
  if (!mapInstance || !userGeolocation) {
    return 0;
  }
  const numTiles = Math.pow(2, mapInstance?.getZoom());
  const destLatLng = mapUtils.getRadiusLatLng(
    userGeolocation,
    userGeolocation.accuracy
  );

  const worldDestPoint = mapUtils.getPointFromLatLng(destLatLng);
  const pixelDestPoint = new window.google.maps.Point(
    worldDestPoint.x * numTiles,
    worldDestPoint.y * numTiles
  );

  const worldCenterPoint = mapUtils.getPointFromLatLng(userGeolocation);
  const pixelCenterPoint = new window.google.maps.Point(
    worldCenterPoint.x * numTiles,
    worldCenterPoint.y * numTiles
  );

  const value = Math.abs(pixelDestPoint.y - pixelCenterPoint.y);

  if (Number.isNaN(value)) {
    return 0;
  }

  return value;
};

export const getMarkerIconConfig = (mapInstance, userGeolocation) => {
  const geoLocationIcon = document.createElement('div');
  geoLocationIcon.setAttribute(
    'style',
    `border-radius: 50%; border: 1px solid ${bubbleMarkerColor}; width: 10px; height: 10px; background: ${bubbleMarkerColor}`
  );
  generateBubbleScale(mapInstance, userGeolocation);
  return {
    content: geoLocationIcon,
  };
};

export const getMarkerBaseConfig = (mapInstance, userGeolocation) => ({
  ...getMarkerIconConfig(mapInstance, userGeolocation),
  position: userGeolocation,
  map: mapInstance,
  zIndex: bubbleMarkerZIndex,
});

export const getPointConfig = (markerBaseConfig) => {
  const config = {
    ...markerBaseConfig,
    zIndex: pointMarkerZIndex,
  };
  config.content.fillOpacity = 1;
  config.content.scale = 5;
  config.content.strokeWeight = 0;
  return config;
};
